import { combineReducers } from 'redux';
import CompaniesReducer from './CompaniesReducer';
import CampaignsReducer from './CampaignsReducer';
import TemplatesReducer from './TemplatesReducer';
import TemplateCategoriesReducer from './TemplateCategoriesReducer';
import SMSTemplatesReducer from './SMSTemplatesReducer';
import SMSTemplateCategoriesReducer from './SMSTemplateCategoriesReducer';
import EmailBroadcastsReducer from './EmailBroadcastsReducer';
import LeadsReducer from './LeadsReducer';
import LeadFilterLogsReducer from './LeadFilterLogsReducer';
import SentEmailsReducer from './SentEmailsReducer';
import EmailAddressesReducer from './EmailAddressesReducer';
import RVMTemplatesReducer from './RVMTemplatesReducer';
import RVMTemplateCategoriesReducer from './RVMTemplateCategoriesReducer';
import VideoTemplatesReducer from './VideoTemplatesReducer';
import VideoTemplateCategoriesReducer from './VideoTemplateCategoriesReducer';
import ReactiveResponseSettingsReducer from './ReactiveResponseSettingsReducer';
import { reducer as toastrReducer} from 'react-redux-toastr';

const rootReducer = combineReducers({
  toastr:                   toastrReducer
, company:                  CompaniesReducer
, campaigns:                CampaignsReducer
, templates:                TemplatesReducer
, templateCategories:       TemplateCategoriesReducer
, smsTemplates:             SMSTemplatesReducer
, smsTemplateCategories:    SMSTemplateCategoriesReducer
, emailBroadcasts:          EmailBroadcastsReducer
, leads:                    LeadsReducer
, leadFilterLogs:           LeadFilterLogsReducer
, sentEmails:               SentEmailsReducer
, emailAddresses:           EmailAddressesReducer
, rvmTemplates:             RVMTemplatesReducer
, rvmTemplateCategories:    RVMTemplateCategoriesReducer
, videoTemplates:           VideoTemplatesReducer
, videoTemplateCategories:  VideoTemplateCategoriesReducer
, reactiveResponseSettings: ReactiveResponseSettingsReducer
});

export default rootReducer;
